/* entry: product */

import './product.scss';
